<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uNpu4z/tc-custom/9781632659101.jpg?1720031866055" alt="This image is the cover for the book 7 Principles of Transformational Leadership"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">7 Principles of Transformational Leadership
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn to flourish as a leader so that a mindset of growth, optimism, and positivity spreads to your employees and shows up in the customer experience.</b><br/><br/> In the world of work, the single greatest asset of successful individuals, teams, and organizations is their mindset—what happens in between their ears. It’s not the corporate strategy, the sales compensation plan, or the market segments they’re pursuing. It is what each leader, team member, and employee chooses to focus on, believe, and create for themselves and others.<br/><br/><i>7 Principles of Transformational Leadership</i> presents the fundamental concepts whose implementation will result in dramatic revenue, performance, and relationship growth. Specifically, leaders will learn to:  Live their professional and personal lives with unbridled purpose and passion.  Execute strategic priorities more effectively and with accelerated results.  Retain the brightest and best talent.  Have employees, key stakeholders, and managers enthusiastically follow them.  Be exemplars of innovation, growth, and positive mindsets.  Cascade excellence throughout their organizations. <br/><br/> You may have employees with all the talent in the world, but you’ll never achieve remarkable results until you change your employees’ mindset. <i>7 Principles of Transformational Leadership</i> will help you convert your human potential into accelerated business results. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hugh Blane
      </h2>
      
      <p class="authorDescription body article"> Hugh Blane is the go-to expert about converting human potential into accelerated business results. His clients call him the Talent Alchemist. Blane&rsquo;s consulting firm, Claris Consulting, is retained by clients such as Sony Pictures, Starbucks, Nordstrom, Wells Fargo, and the University of Texas A&amp;M in Qatar to challenge assumptions, jettison complacency, and catapult growth. Blane once ran with the bulls in Pamplona and learned how not to get gored. He resides in the small beach community of Normandy Park, Washington, with his wife, Alyson, and a giant black Schnauzer called Brooks. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Career Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58783d7a